import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useStringInput, { StringInput } from "@/components/form/string-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S06 = (props) => {
    const registration = useStringInput({
        name: "sale[car][reg]",
        label: "Hva er registreringsnummeret?",
        placeholder: "Registreringsnummer",
        required: false,
        ...props,
    })

    const typeMakeModel = useStringInput({
        name: "sale[car][year]",
        label: "Type/ merke/ modell",
        placeholder: "Type, merke, modell",
        ...props,
    })

    const price = useRadioInput({
        name: "sale[car][price]",
        label: "Hva var prisen?",
        tooltip: "Prisen kan påvirke forventningene til kjøperen. Når du kjøper et dyrere objekt, kan du ha høyere forventninger til kvalitet og ytelse. Derfor kan det være lettere å klage på feil eller mangler når du har betalt en høy salgssum, da du kan forvente at det skal være av høyere kvalitet.",
        options: {
            data: [
                { label: "0 - 50 000", value: "0-50" },
                { label: "50 000 - 200 000", value: "50-200" },
                { label: "200 000- 500 000", value: "200-500" },
                { label: "500 000 +", value: "500+" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om kjøpet">
            <div className="group gg-3">
                <StringInput {...registration.props}/>
                <StringInput {...typeMakeModel.props}/>
            </div>

            <RadioInput {...price.props} className="mt-7"/>
        </Wrapper>
    );
};

export default S06;
